var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51649 5.62951H5.62949V1.51651C5.62949 1.1529 5.77394 0.804177 6.03105 0.547064C6.28816 0.289952 6.63688 0.145508 7.00049 0.145508C7.3641 0.145508 7.71282 0.289952 7.96994 0.547064C8.22705 0.804177 8.37149 1.1529 8.37149 1.51651V5.62951H12.4835C12.8471 5.62951 13.1958 5.77395 13.4529 6.03106C13.71 6.28818 13.8545 6.6369 13.8545 7.00051C13.8545 7.36412 13.71 7.71284 13.4529 7.96995C13.1958 8.22706 12.8471 8.37151 12.4835 8.37151H8.37149V12.4835C8.37149 12.8471 8.22705 13.1958 7.96994 13.453C7.71282 13.7101 7.3641 13.8545 7.00049 13.8545C6.63688 13.8545 6.28816 13.7101 6.03105 13.453C5.77394 13.1958 5.62949 12.8471 5.62949 12.4835V8.37151H1.51649C1.15288 8.37151 0.804161 8.22706 0.547049 7.96995C0.289936 7.71284 0.145492 7.36412 0.145492 7.00051C0.145492 6.6369 0.289936 6.28818 0.547049 6.03106C0.804161 5.77395 1.15288 5.62951 1.51649 5.62951Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion10);
export default __webpack_public_path__ + "static/media/Union_10.2815d903fbbcbe5ac2b05f86cfe86edb.svg";
export { ForwardRef as ReactComponent };